import { Button } from "@components/Button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@components/Dialog";

import { useDeleteRemarkMutation } from "@storage/queries/remarks";

interface DeleteRemarkDialogProps {
	userId: string;
	onClose: () => void;
}

export const DeleteRemarkDialog = ({ userId, onClose }: DeleteRemarkDialogProps) => {
	const deleteRemarkMutation = useDeleteRemarkMutation();

	const handleDelete = () => {
		deleteRemarkMutation.mutate({ id: userId });
		onClose();
	};

	return (
		<Dialog open onOpenChange={onClose}>
			<DialogContent className="max-w-95">
				<DialogHeader>
					<DialogTitle>Delete note</DialogTitle>
				</DialogHeader>
				<DialogFooter>
					<Button type="error" onClick={handleDelete} wide>
						Delete
					</Button>
					<Button type="secondary" onClick={onClose} wide>
						Cancel
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
